module.exports = __webpack_public_path__ + "img/icon_map_1_on_011.a5855bcc.png";